import React, { useRef, useEffect } from 'react';
import _ from 'lodash'; // import cx from 'classnames'

import { useSelector, useDispatch } from 'react-redux';
import { MapContainer, TileLayer, useMapEvents } from 'react-leaflet';
import ChangeView from '../ui/map_changeView';
import TrafficEventMarkers from './trafficEvent-marker';
import 'leaflet/dist/leaflet.css';
import '@bepo65/leaflet.fullscreen/Control.FullScreen.css'; // redux

import { setMapCenter, setMapZoom, setMapBounds } from '../../redux/traffic-dashboard'; // const defaultCenter = { lat: 25.076561138063358, lng: 121.57435930926108 }

var hanldeMapCenterFormat = function hanldeMapCenterFormat(center) {
  if (_.isEmpty(center)) return {
    lat: 0,
    lng: 0
  };
  var latlngAry = center.split(', ');
  return {
    lat: latlngAry[1],
    lng: latlngAry[0]
  };
};

var TrafficEventMap = /*#__PURE__*/React.memo(function (props) {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      _useSelector$envCfg = _useSelector.envCfg,
      gisMapServiceApiUrl = _useSelector$envCfg.gisMapServiceApiUrl,
      gisMapZoomLevelMax = _useSelector$envCfg.gisMapZoomLevelMax,
      gisMapZoomLevelMin = _useSelector$envCfg.gisMapZoomLevelMin,
      gisMapInitViewportCenter = _useSelector$envCfg.gisMapInitViewportCenter,
      gisMapInitViewportZoom = _useSelector$envCfg.gisMapInitViewportZoom,
      _useSelector$trafficD = _useSelector.trafficDashboard,
      mapCenter = _useSelector$trafficD.mapCenter,
      mapZoom = _useSelector$trafficD.mapZoom;

  var dispatch = useDispatch();

  var _mapRef = useRef();

  var MapEvent = function MapEvent() {
    var map = useMapEvents({
      zoomlevelschange: function zoomlevelschange(e) {
        dispatch(setMapBounds(e.target.getBounds()));
      },
      moveend: function moveend(e) {
        dispatch(setMapBounds(e.target.getBounds()));
      }
    });
    return null;
  };

  useEffect(function () {
    return function () {
      dispatch(setMapCenter({}));
      dispatch(setMapZoom(null));
    };
  }, []);
  if (!gisMapServiceApiUrl) return null;
  return /*#__PURE__*/React.createElement(MapContainer, {
    whenCreated: function whenCreated(mapInstance) {
      _mapRef.current = mapInstance;
      setTimeout(function () {
        mapInstance.invalidateSize();
      }, 250);
    },
    id: "trafficEvent-map",
    center: hanldeMapCenterFormat(gisMapInitViewportCenter),
    zoom: gisMapInitViewportZoom,
    zoomControl: false,
    attributionControl: false
  }, /*#__PURE__*/React.createElement(MapEvent, null), /*#__PURE__*/React.createElement(ChangeView, {
    center: mapCenter,
    zoom: mapZoom ? mapZoom : gisMapInitViewportZoom
  }), /*#__PURE__*/React.createElement(TileLayer, {
    url: gisMapServiceApiUrl,
    maxZoom: gisMapZoomLevelMax,
    minZoom: gisMapZoomLevelMin,
    crossOrigin: true
  }), /*#__PURE__*/React.createElement(TrafficEventMarkers, null));
});
export default TrafficEventMap;